import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../utils/cn';
interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  variant?: 'primary' | 'secondary';
  className?: string;
  scrollTo?: string;
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  className,
  scrollTo,
  href,
  onClick,
  ...props
}: ButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (href) {
      window.open(href, '_blank', 'noopener,noreferrer');
    }
    if (scrollTo) {
      document.getElementById(scrollTo)?.scrollIntoView({
        behavior: 'smooth'
      });
    }
    onClick?.(e);
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={cn('inline-flex items-center justify-center px-8 py-4 rounded-full font-bold text-lg transition-colors shadow-sm', variant === 'primary' ? 'bg-terracotta text-white hover:bg-terracotta-600 shadow-terracotta/20' : 'bg-cream-100 text-terracotta border-2 border-terracotta hover:bg-cream-200', className)} onClick={handleClick} {...props} data-id="element-236">
      {children}
    </motion.button>;
}